/* ============================================================
   ORALYS THEME — theme.js
   JS partagé : drawer, sticky bar, FAQ accordion, cart
   ============================================================ */

/* ---- MOBILE DRAWER ---- */
function openDrawer() {
  document.getElementById('navDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  document.getElementById('navDrawer').classList.remove('open');
  document.body.style.overflow = '';
}

/* ---- FAQ ACCORDION ---- */
function toggleFaq(el) {
  const item = el.closest('.faq-item') || el.parentElement;
  const answer = item.querySelector('.faq-answer') || item.nextElementSibling;
  const isOpen = item.classList.contains('open');

  // Fermer tous les autres
  document.querySelectorAll('.faq-item.open, .faq-q.open').forEach(function(openEl) {
    openEl.classList.remove('open');
    const ans = openEl.querySelector('.faq-answer') || openEl.nextElementSibling;
    if (ans) ans.style.maxHeight = null;
  });

  if (!isOpen) {
    item.classList.add('open');
    if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
  }
}

/* ---- STICKY BAR OBSERVER ---- */
function initStickyBar(heroCtaSelector, stickyBarId) {
  var stickyCta = document.getElementById(stickyBarId || 'stickyCta');
  var heroCta = document.querySelector(heroCtaSelector || '[data-sticky-trigger]');

  if (!stickyCta) return;

  // Observer la section hero entière — la bar apparaît quand le hero est sorti du viewport
  var heroSection = document.getElementById('heroSection');
  var triggerEl = heroSection || heroCta;

  if (triggerEl) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyCta.classList.add('visible');
        } else {
          stickyCta.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(triggerEl);
  } else {
    // Fallback : apparaît après 80vh de scroll
    window.addEventListener('scroll', function() {
      if (window.scrollY > window.innerHeight * 0.8) {
        stickyCta.classList.add('visible');
      } else {
        stickyCta.classList.remove('visible');
      }
    }, { passive: true });
  }
}

/* ---- CART COUNT UPDATE ---- */
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function() {});
}

/* ---- ADD TO CART (Shopify AJAX API) ---- */
/* Uses XHR to bypass any window.fetch interceptors (e.g. Appstle) */
function addToCart(variantId, quantity, onSuccess, sellingPlanId) {
  var payload = { id: variantId, quantity: quantity || 1 };
  if (sellingPlanId) payload.selling_plan = sellingPlanId;
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = function() {
    updateCartCount();
    if (typeof onSuccess === 'function') {
      try { onSuccess(JSON.parse(xhr.responseText)); } catch(e) {}
    }
  };
  xhr.onerror = function() { console.error('addToCart error'); };
  xhr.send(JSON.stringify(payload));
}

/* ---- VARIANT SELECTOR ---- */
function initVariantSelector() {
  var selectors = document.querySelectorAll('[data-variant-selector]');
  selectors.forEach(function(selector) {
    selector.addEventListener('change', function() {
      var selectedId = this.value;
      var priceEl = document.querySelector('[data-variant-price]');
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.dataset.variantId = selectedId;
      // Le prix sera mis à jour via Liquid au chargement initial ;
      // pour une vraie mise à jour AJAX, utiliser l'API Shopify variants.
    });
  });
}

/* ---- PURCHASE TYPE TOGGLE (once / subscription) ---- */
function initPurchaseToggle() {
  var toggleBtns = document.querySelectorAll('[data-purchase-type]');
  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      toggleBtns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var type = this.dataset.purchaseType;
      document.querySelectorAll('[data-price-once]').forEach(function(el) {
        el.style.display = type === 'once' ? '' : 'none';
      });
      document.querySelectorAll('[data-price-sub]').forEach(function(el) {
        el.style.display = type === 'sub' ? '' : 'none';
      });
    });
  });
}

/* ---- CARROUSEL AVIS CUSTOM (source Judge.me cachée) ---- */
function initCustomReviews(sourceId, trackId, prevId, nextId) {
  var source  = document.getElementById(sourceId);
  var track   = document.getElementById(trackId);
  if (!source || !track) return;

  var prevBtn = document.getElementById(prevId);
  var nextBtn = document.getElementById(nextId);
  var index   = 0;

  function isMobile() { return window.innerWidth <= 768; }
  function getVisible() { return isMobile() ? 1 : 3; }

  function buildStars(n) {
    var s = '';
    for (var i = 0; i < 5; i++) s += (i < n) ? '★' : '☆';
    return s;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(ch) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[ch];
    });
  }

  function extractReviews() {
    var reviews = [];
    source.querySelectorAll('[data-review-item]').forEach(function(item) {
      if (!item.dataset.text || !item.dataset.text.trim()) return;
      reviews.push({
        stars:  parseInt(item.dataset.stars, 10) || 5,
        text:   item.dataset.text.trim(),
        author: item.dataset.author || '',
        date:   item.dataset.date || ''
      });
    });
    if (reviews.length) return reviews;

    source.querySelectorAll('.jdgm-carousel-item').forEach(function(item) {
      var stars    = item.querySelectorAll('.jdgm-star.jdgm--on').length || 5;
      var bodyEl   = item.querySelector('.jdgm-carousel-item__review-body');
      var authorEl = item.querySelector('.jdgm-carousel-item__reviewer-name');
      var dateEl   = item.querySelector('.jdgm-carousel-item__timestamp, time');
      if (!bodyEl || !bodyEl.textContent.trim()) return;
      reviews.push({
        stars:  stars,
        text:   bodyEl.textContent.trim(),
        author: authorEl ? authorEl.textContent.trim() : '',
        date:   dateEl   ? dateEl.textContent.trim()   : ''
      });
    });
    return reviews;
  }

  function cardHtml(r) {
    var verifiedLabel = source.dataset.reviewVerifiedLabel || 'Achat vérifié';
    return '<div class="review-card">' +
      '<div class="review-top">' +
        '<div class="review-stars">' + buildStars(r.stars) + '</div>' +
        '<div class="review-date">' + escapeHtml(r.date) + '</div>' +
      '</div>' +
      '<div class="review-text">\u201c' + escapeHtml(r.text) + '\u201d</div>' +
      '<div class="review-author">' + escapeHtml(r.author) +
        ' <span class="review-verified">\u2713 ' + escapeHtml(verifiedLabel) + '</span>' +
      '</div>' +
    '</div>';
  }

  function render(reviews) {
    track.innerHTML = reviews.map(cardHtml).join('');
    goTo(0, false);
  }

  function goTo(i, animate) {
    var cards = track.querySelectorAll('.review-card');
    if (!cards.length) return;
    var vis = getVisible();
    index = Math.max(0, Math.min(i, cards.length - vis));
    var gap = isMobile() ? 0 : 16;
    var w = cards[0].offsetWidth + gap;
    track.style.transition = (animate === false) ? 'none' : 'transform 0.35s ease';
    track.style.transform = 'translateX(-' + (index * w) + 'px)';
    if (prevBtn) prevBtn.disabled = (index === 0);
    if (nextBtn) nextBtn.disabled = (index >= cards.length - vis);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(index - 1, true); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(index + 1, true); });

  /* Swipe touch */
  var touchStartX = 0;
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? index + 1 : index - 1, true);
  }, { passive: true });

  /* Resize */
  window.addEventListener('resize', function() { goTo(index, false); }, { passive: true });

  function tryInit() {
    var reviews = extractReviews();
    if (!reviews.length) return false;
    render(reviews);
    return true;
  }

  if (tryInit()) return;
  var obs = new MutationObserver(function() { if (tryInit()) obs.disconnect(); });
  obs.observe(source, { childList: true, subtree: true });
  setTimeout(function() { obs.disconnect(); tryInit(); }, 12000);
}



/* ---- INIT AU CHARGEMENT ---- */
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
  initVariantSelector();
  initPurchaseToggle();

  if (document.getElementById('stickyCta')) {
    initStickyBar();
  }

  if (document.getElementById('jm-source-pdp')) {
    initCustomReviews('jm-source-pdp', 'jm-track-pdp', 'jm-prev-pdp', 'jm-next-pdp');
  }

  if (document.getElementById('jm-source-home')) {
    initCustomReviews('jm-source-home', 'jm-track-home', 'jm-prev-home', 'jm-next-home');
  }
});
